import {rawHttp} from "../services/http";

export const getDestinationLinkFromConfiguration = async (configurationLink: string): Promise<string> => {
    const destinationLink = (await rawHttp.get(configurationLink)).data;
    const isString = typeof destinationLink === 'string' || destinationLink instanceof String;
    if (!isString || !(destinationLink as string).startsWith('http')) {
        throw 'invalid link';
    }
    return destinationLink as string;
}